export default __webpack_public_path__ + "static/media/705.0157e2c9.png";